import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import { FaCircleUser } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { UseAuth } from "src/auth/AuthContext";
import { DepositPics } from "src/types";
import "process"

type PreviewImageProps = {
  isOpen: boolean;
  closeModal(): void;
  img: string
  title: any
  description:any
  arrayGallery?: DepositPics[]
};

const PreviewImage = ({ isOpen, closeModal, img, title ,description, arrayGallery }: PreviewImageProps) => {
  const {user} = UseAuth()
  const navigate = useNavigate()
  const [currentImg, setCurrentImg] = useState<string>(img)

  const handleKeyPress = (event:any) => {
    alert(event.key)
  }
  useEffect(() => {
    setCurrentImg(img)
    
  }, [img])
  
  const handleNextPrev = (action:string) => {
    let posFind = 0
     arrayGallery?.map((a,i) => {
      if(currentImg === a.photoUrl){
        posFind = i
      }
    })
    if(arrayGallery){
        posFind = action === 'next' ? Number(posFind+1):Number(posFind-1)
      if(arrayGallery[posFind] === undefined){
        posFind = action === 'next' ? 0 : arrayGallery.length-1 
      }
      setCurrentImg(arrayGallery[posFind].photoUrl)
    }
  }
  return (
    <div  onKeyUp={(e )=> handleKeyPress(e)}>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative" onClose={closeModal}
          style={{zIndex: '100000000'}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-stone-900 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-start justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full mt-0 max-w-100 transform overflow-hidden  bg-transparent text-left align-middle shadow-xl transition-all">
                      <span
                        onClick={() => closeModal()}
                        className="close-dialog-button-typeleft"
                      >
                        x
                      </span>
                  <div className="grid col-span-1 md:grid-cols-4">

                    <div className="relative bg-[#000] md:col-span-3" style={{borderRadius: "0!important"}}>
                    {(arrayGallery?.length || 0) > 0 &&
                      <>
                          <div className="absolute bg-arrow-previewimage right-3" style={{top:"50%"}}>
                            <FaArrowAltCircleRight 
                              onClick={() => handleNextPrev('next')}
                            size={43} className="text-white cursor-pointer"  />
                          </div>
                          <div className="absolute bg-arrow-previewimage left-3" style={{top:"50%"}}>
                            <FaArrowAltCircleLeft 
                              onClick={() => handleNextPrev('prev')}
                            size={43} className="text-white cursor-pointer"  />
                          </div>
                      </>
                      }
                      <img
                        alt="close"
                        src={currentImg}
                        className="w-auto mx-auto image-type-preview unselected-css"
                        style={{ height: "100vh" }}
                      />
                    </div>
                    <div className="bg-white md:col-span-1 pt-10 text-base pb-20">
                      <div className="text-sm px-4 relative font-bold md:-top-5 unselected-css">
                        Presiona esc para salir.
                      </div>
                      <div className="mb-6 border-b border-stone-300">
                        <div className="py-2 px-4 flex items-center font-normal helvetica capitalize text-sm md:text-base gap-2 border border-stone-200 bg-stone-100 ">
                          <FaCircleUser size={24} />
                          <span className="text-green-admin-light underline cursor-pointer" onClick={() => navigate(`/usuario/${user?.id}`)}>
                            {user?.fullname}
                          </span>
                        </div>
                      </div>
                      <div className="font-medium text-sm px-4">
                        {title}
                      </div>
                      <div className="mt-4 font-normal  text-sm px-4">
                        {description}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};
export default PreviewImage;
